<div
  class="menubar-hoverable header-fixed menubar-pin"
  style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #ffffff;
  "
>
  <!-- header -->

  <!-- menu -->

  <div id="base">
    <div id="content" class="tc-container-main">
      <div *ngIf="!loadingData && !showTcPreviewPage" class="tc-container">
        <div class="page-heading-tc">
          {{ 'tcGenerator' | translate }}
        </div>
        <div class="data-main-container-tc-generator">
          <div class="job-container-main">
            <div class="job-container">
              <div class="pending-service-heading">
                <div class="pending-service-text">
                  {{ 'pendingServices' | translate }}
                </div>

                <!-- HTML template -->
                <div
                  (click)="refreshList()"
                  [ngClass]="
                    isRefreshing ? 'refresh-button-run' : 'refresh-button'
                  "
                >
                  <i class="ri-restart-line"></i>
                </div>
              </div>
              <table class="job-info">
                <thead>
                  <tr class="header-services">
                    <th>{{ 'serviceId' | translate }}</th>
                    <th class="count-number-tc">{{ 'count' | translate }}</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <ng-container *ngIf="tcJobInfo && tcJobInfo.length > 0">
                  <tbody class="data-services" *ngFor="let item of tcJobInfo">
                    <tr>
                      <td>#{{ item.serviceId }}</td>
                      <td
                        (click)="openStudentDetailsForTc(item.pkJobDetailId)"
                        class="count-number-tc"
                      >
                        {{ item.scheduledStudentCount }}
                      </td>
                      <td
                        [ngClass]="{
                          'pending-state': item.jobStatus === 'pending',
                          'generated-state': item.jobStatus === 'done',
                          'cancelled-state': item.jobStatus === 'cancelled',
                          'inprogress-state': item.jobStatus === 'inprogress'
                        }"
                      >
                        <ng-container
                          *ngIf="
                            item.jobStatus === 'cancelled' &&
                            item.isAllTcGenerated !== 1
                          "
                        >
                          ---
                        </ng-container>
                        <ng-container *ngIf="item.jobStatus === 'inprogress'">
                          <i class="ri-history-fill"></i
                          >{{ 'inProgress' | translate }}
                        </ng-container>
                        <ng-container *ngIf="item.jobStatus === 'pending'">
                          <i class="ri-history-fill tc-icon-space"></i
                          >{{ 'pending' | translate }}
                        </ng-container>
                        <ng-container *ngIf="item.isAllTcGenerated === 1">
                          <span class="tc-view-icon" (click)="handleViewButton(item.pkJobDetailId);">
                            <i class="ri-eye-line tc-icon-space"></i>
                            {{ 'view' | translate }}
                          </span>
                        </ng-container>
                      </td>

                      <td
                        [ngClass]="{
                          'generated-state': item.jobStatus === 'inprogress',
                          'cancelled-state': item.jobStatus === 'pending',
                          'edit-state': item.isAllTcGenerated === 1,
                          'default-state': true
                        }"
                      >
                        <!-- Show Cancel if the jobStatus is 'pending' -->
                        <button
                          [disabled]="updatingList"
                          (click)="
                            openPopUpForJobCancellation(item.pkJobDetailId)
                          "
                          class="button-cancel"
                          *ngIf="item.jobStatus === 'pending'"
                        >
                          {{ 'cancel' | translate }}
                        </button>

                        <!-- Show Edit if isAllTcGenerated is 1 -->
                        <span
                          class="edit-tc-format"
                          (click)="
                            openPopUpForEditJob(
                              item.excelTemplateUrl,
                              item.pkJobDetailId
                            )
                          "
                          *ngIf="
                            item.isAllTcGenerated === 1 &&
                            item.jobStatus === 'done'
                          "
                        >
                          <i class="ri-edit-line tc-icon-space"></i
                          >{{ 'edit' | translate }}
                        </span>

                        <!-- Optionally, show empty if neither condition matches -->
                        <span
                          class="cancelled-tc-state"
                          *ngIf="
                            (item.jobStatus !== 'pending' &&
                              item.jobStatus !== 'inprogress' &&
                              item.isAllTcGenerated !== 1) ||
                            item.jobStatus === 'cancelled'
                          "
                          >{{ 'cancelled' | translate }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </ng-container>
              </table>
            </div>
            <div>
              <input
                (change)="fileUploadExcel($event)"
                class="upload-excel"
                accept=".xls, .xlsx"
                type="file"
                id="upload-template"
              />
              <label class="upload-excel-label" for="upload-template">
                <div class="upload-sheet-tc">
                  <div class="upload-sheet-icon-text">
                    <img
                      class="upload-icon-sheet"
                      src="../../assets/img/upload_icon.png"
                      alt=""
                    />
                    <div class="upload-text">{{ 'uploadExcel' | translate }}</div>
                  </div>
                  <span
                    (click)="
                      downloadSampleExcelFile(tcTemplates[0]?.sampleDocumentUrl)
                    "
                  >
                    <button class="download-template-tc-button">
                      {{ 'download' | translate }}
                    </button>
                  </span>

                  <div class="visit-heading-tc">
                    <span>{{ 'or' | translate }}</span>
                    <span
                      (click)="openStudentPage()"
                      class="open-student-page"
                      >{{ 'visit' | translate }}</span
                    >
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div class="template-preview-container">
            <div>
              <img
                class="tc-template-pic"
                src="{{ tcTemplates[0]?.defaultTemplateImageUrl || '#' }}"
                alt="Certificate preview"
              />
            </div>
            <span class="template-preview-heading">{{ 'preview' | translate }}</span>
          </div>
        </div>
      </div>
      <div style="height: 70vh" *ngIf="loadingData && !showTcPreviewPage">
        <app-new-loader></app-new-loader>
      </div>
      <app-transfer-certificate-preview *ngIf="showTcPreviewPage" [selectedJobId]="selectedJobId" (backArrowClicked)="handleBackArrowClick()">
      </app-transfer-certificate-preview>
    </div>
  </div>

  <!-- Modal-for-cancellation-job -->
  <div
    class="modal fade"
    id="cancelJob"
    tabindex="-1"
    role="dialog"
    aria-labelledby="simpleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-tc-cancel" role="document">
      <div class="modal-content tc-job-cancel-modal">
        <div class="modal-body tc-cancel-message">
          {{ 'cancelTCGeneration' | translate }}
        </div>
        <div class="tc-cancel-buttons">
          <button (click)="closeJobCancellationPopup()" class="no-button">
            {{ 'no' | translate }}
          </button>
          <button
            [disabled]="tcCancelling"
            class="yes-button"
            (click)="cancelSelectedJob()"
          >
            <app-button-loader *ngIf="tcCancelling"></app-button-loader>
            <span *ngIf="!tcCancelling">{{ 'yes' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal-for-cancellation-job -->
  <div
    class="modal fade"
    id="editJob"
    tabindex="-1"
    role="dialog"
    aria-labelledby="simpleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-tc-cancel" role="document">
      <div class="modal-content tc-job-cancel-modal">
        <div class="modal-body tc-cancel-message">
          {{ 'editServices' | translate }}
        </div>

        <div class="message-edit">
          {{ 'editMessage' | translate }}
        </div>
        <div class="tc-cancel-buttons">
          <button (click)="closePopUpForEditJob()" class="no-button">
            {{ 'no' | translate }}
          </button>
          <button class="yes-button">
            <app-button-loader *ngIf="tcCancelling"></app-button-loader>
            <span (click)="downloadTemplateForEdit()" class="proceed-edit">
              {{ 'proceed' | translate }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal-for-upload-excel-job -->
  <div
    class="modal fade"
    id="uploadingExcel"
    tabindex="-1"
    role="dialog"
    aria-labelledby="simpleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-tc-cancel" role="document">
      <div class="modal-content tc-job-cancel-modal">
        <div class="modal-body tc-cancel-message">
          <span *ngIf="isUploadingExcel">{{ 'excelUploading' | translate }}</span>
          <span
            *ngIf="uploadSuccess && !isUploadingExcel"
            class="success-upload-excel-tc"
            >{{ 'uploadSuccessfully' | translate }}</span
          >
          <span
            *ngIf="!isUploadingExcel && !uploadSuccess"
            class="error-upload-excel-tc"
            >{{ 'uploadFailed' | translate }}</span
          >
        </div>
        <div class="spinner-container">
          <div *ngIf="isUploadingExcel" class="spinner"></div>
        </div>
        <div *ngIf="uploadSuccess" class="message-edit">
          {{ 'uploadSuccess' | translate }}
        </div>

        <div
          *ngIf="uploadSuccess && !isUploadingExcel"
          class="message-edit success-job-id"
        >
          {{ 'jobId' | translate }} : #{{ tcJobId }}
        </div>

        <div *ngIf="!isUploadingExcel && !uploadSuccess" class="message-edit">
          {{ 'errorLocation' | translate }}
        </div>
        <div
          *ngIf="tcUploadErrors && tcUploadErrors.length > 0 && !uploadSuccess"
          class="error-tc-excel"
        >
          <div class="error-list-tc">
            <ul *ngIf="tcUploadErrors && tcUploadErrors.length > 0">
              <li *ngFor="let item of tcUploadErrors">
                {{ 'column' | translate }} {{ item.columnName }} - {{ 'row' | translate }}
                {{ item.row }}
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="!isUploadingExcel && !uploadSuccess" class="message-edit">
          {{ 'messageUploadAgain' | translate }}
        </div>
        <div class="tc-cancel-buttons">
          <button (click)="closePopUpForUploadingExcel()" class="ok-button">
            {{ 'ok' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal-for-upload-student-info -->
  <div
    class="modal"
    id="studentDetailsTc"
    tabindex="-1"
    role="dialog"
    aria-labelledby="simpleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-tc-cancel" role="document">
      <div class="modal-content student-tc-list">
        <div>
          <div class="modal-body student-list-heading">
            <span class="student-list-heading-font">{{ 'studentList' | translate }}</span>
            <span
              class="close-button-student-list"
              (click)="closePopOfStudentList()"
              ><i class="ri-close-line"></i
            ></span>
          </div>
          <table class="student-tc-info">
            <thead class="student-info-header">
              <tr class="student-tc-header-info">
                <th>{{ 'registrationId' | translate }}</th>
                <th>{{ 'name' | translate }}</th>
                <th>{{ 'class' | translate }}</th>
                <th>{{ 'section' | translate }}</th>
              </tr>
            </thead>

            <ng-container
              *ngIf="studentListForTc && studentListForTc.length > 0"
            >
              <tbody
                *ngIf="studentListForTc && studentListForTc.length > 0"
                class="student-tc-info-body"
              >
                <tr *ngFor="let item of studentListForTc">
                  <td>{{ item.registrationId }}</td>
                  <td>{{ item.studentName }}</td>
                  <td>{{ item.className }}</td>
                  <td>{{ item.classNumber }}</td>
                </tr>
              </tbody>
            </ng-container>
          </table>
        </div>

        <div *ngIf="fetchingStudentList" class="student-list-loader">
          <div class="spinner"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- static content -->
</div>
